import React, { useEffect } from "react"
import { graphql } from "gatsby"
import Seo from "../components/seo"

import Layout from "../components/layout"
import Title from "../components/title"
import MagazineMainNav from "../components/magazine-main-nav"
import BtnShowAll from "../components/btn-show-all"
import PostListItem from "../components/post-list-item"
import PostListItemFullWidth from "../components/post-list-item-full-width"
import ogImage from "../images/thumbnail.jpg"

const findTwoPostsByCategoryId = (posts, categoryId) => {
  let postsFound = []

  posts.forEach((post) => {
    if (post.node.categoryId === categoryId) {
      postsFound.push(post)
    }
  })

  return postsFound.splice(0, 2)
}

const IndexPage = ({ data: { site, allCategoryJson, allPostsJson }, location }) => {

  const cats = allCategoryJson.edges
  const posts = allPostsJson.edges
  
  const firstPost = [...posts].splice(0, 1)
  const newPosts  = [...posts].splice(1, 2)

  const newPostsComponents = newPosts.map((post) => {
    return (
      <li>
        <PostListItem post={post.node} location={location} />
      </li>
    )
  })

  const categoryComponents = cats.map((category) => {
    return (
      <>
        <section className={'article-list ' + category.node.slug}>
          <h1>{category.node.nameEN}</h1>
          <h2>{category.node.description}</h2>
          <ul>
            {
              findTwoPostsByCategoryId(posts, category.node.categoryId).map((post) => {
                return (
                  <li>
                    <PostListItem post={post.node} location={location} />
                  </li>
                )
              })
            }
          </ul>
          <BtnShowAll categoryId={category.node.slug} />
        </section>
      </>
    )
  })

  useEffect(() => {
  })

  return (
    <Layout>
      <Seo title={site.siteMetadata.title} description={site.siteMetadata.description} ogImage={ogImage} />
      <section id="content-header">
        <Title />
        <MagazineMainNav />
      </section>
      <section id="pickup-article">
        { 
          firstPost.length ? (
            <PostListItemFullWidth post={firstPost[0].node} location={location} />
          ) : ''
        }
      </section>
      <div className="wrapper">
        <section className="article-list latest">
          <h1>最新</h1>
          <h2>ラクサスの最新ニュースをお届け。</h2>
          <ul>
            {newPostsComponents}
          </ul>
        </section>
        {categoryComponents}
      </div>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query allPostsAndCategories {
    site {
      siteMetadata {
        title
      }
    }
    allPostsJson(sort: {fields: postedAt, order: DESC}) {
      edges {
        node {
          id
          title
          postId
          postedAt
          categoryId
          thumbnailSquare {
            src {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          thumbnailLandscape {
            src {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
